import React from 'react';
import Button from '@mui/material/Button';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import { Typography } from '@mui/material';
import { downloader } from './downloader';


export default function InputFileDownload(props: any) {
  const { path } = props

  let filename: any = path.length > 0 ? new URL(path).pathname.split('/').at(-1) : ''

  return (
    <React.Fragment>
      {(path.length > 0) && (<>
        <Button
          component="label"
          onClick={() => downloader(path, filename ? filename : 'noname')}
          variant='contained'
          size='small'
          startIcon={<CloudDownloadIcon />}>
          Descargar
        </Button>
        <Typography sx={{ fontStyle: 'italic' }} variant="body1" paddingY={'1vh'}>
          {filename}
        </Typography>
      </>)}
    </React.Fragment>
  );

}